import { CommonErrorModal } from "@app/components/modals/CommonErrorModal";
import { Path } from "@app/route_path";
import { useModal } from "@shortsworks/ui";
import { setAuthToken, useSigninWithPlatform } from "@shortsworks/user-api";
import { LoaderCircle } from "lucide-react";
import { useEffect } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";

// 위치 변경 필요
export const CAFE24_SCOPES = `
    mall.read_application,
    mall.write_application,
    mall.read_category,
    mall.read_product,
    mall.read_collection,
    mall.read_supply,
    mall.read_personal,
    mall.write_personal,
    mall.read_order,
    mall.write_order,
    mall.read_customer,
    mall.read_store,
    mall.read_promotion
    mall.read_design,
    mall.write_design   
`;

// CAFE24 플랫폼을 통한 로그인 및 회원가입 2가지 구현 필요
export const LoginByCafe24 = () => {
  const { showModal } = useModal();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const mallId = searchParams.get("mall_id") as string;
  const {
    data: signInWithPlatformData,
    isSuccess: isSuccessSignInWithPlatform,
    isError: isErrorSignInWithPlatform,
  } = useSigninWithPlatform(mallId);

  useEffect(() => {
    (async () => {
      if (!mallId) {
        showModal(CommonErrorModal, { title: "잘못된 접근입니다." });
        return navigate(Path.LOGIN);
      }
    })();
  }, []);

  useEffect(() => {
    if (isErrorSignInWithPlatform) {
      showModal(CommonErrorModal, { title: "잘못된 접근입니다." });
      return navigate(Path.LOGIN);
    }
    if (isSuccessSignInWithPlatform) {
      setAuthToken({
        // @ts-ignore
        accessToken: signInWithPlatformData.data.accessToken,
        // @ts-ignore
        refreshToken: signInWithPlatformData.data.refreshToken,
      });
      return navigate(Path.DASHBOARD);
    }
  }, [isSuccessSignInWithPlatform, isErrorSignInWithPlatform]);

  return (
    <div className="flex w-dvw h-dvh items-center justify-center">
      <LoaderCircle className="w-6 h-6 mr-2 animate-spin" />
    </div>
  );
};
